import type { ReactNode } from 'react';
import React from 'react';

import { Pressable } from '@atlaskit/primitives/compiled';
import { cssMap, cx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { ShortcutLozenge } from './ShortcutLozenge.tsx';

interface BOEQuickActionButtonProps {
	children: ReactNode;
	shortcut?: string;
	icon?: () => ReactNode;
	onClick?: () => void;
	isDisabled?: boolean;
	isActive?: boolean;
	testId?: string;
}

const styles = cssMap({
	button: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.050'),
		paddingInlineStart: token('space.100'),
		paddingInlineEnd: token('space.100'),
		paddingBlockStart: token('space.075'),
		paddingBlockEnd: token('space.075'),
		borderRadius: token('radius.medium'),
		backgroundColor: token('elevation.surface'),
		cursor: 'pointer',
		'&:hover': {
			boxShadow: token('elevation.shadow.overlay'),
		},
	},
	active: {
		backgroundColor: token('color.background.neutral.subtle.pressed'),
	},
});

export const BOEQuickActionButton = ({
	children,
	shortcut,
	icon,
	onClick,
	isDisabled,
	isActive,
	testId,
}: BOEQuickActionButtonProps) => {
	return (
		<Pressable
			testId={testId}
			onClick={onClick}
			isDisabled={isDisabled}
			xcss={cx(styles.button, isActive && styles.active)}
			style={{
				border: `${token('border.width')} solid ${token('color.border')}`,
			}}
		>
			{icon?.()}
			{children}
			{shortcut && <ShortcutLozenge>{shortcut}</ShortcutLozenge>}
		</Pressable>
	);
};
